/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import UserLabItemEnum from './user-lab-item-enum';
import UserLabItemEnumDetail from './user-lab-item-enum-detail';
import UserLabItemEnumUpdate from './user-lab-item-enum-update';
import UserLabItemEnumDeleteDialog from './user-lab-item-enum-delete-dialog';

const UserLabItemEnumRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<UserLabItemEnum />} />
    <Route path="new" element={<UserLabItemEnumUpdate />} />
    <Route path=":id">
      <Route index element={<UserLabItemEnumDetail />} />
      <Route path="edit" element={<UserLabItemEnumUpdate />} />
      <Route path="delete" element={<UserLabItemEnumDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default UserLabItemEnumRoutes;
